import React, { useEffect, useState } from "react";
import { BreadCrumbProp, BreadCrumb } from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { InlineTab, InlineTabContent } from "../../../components/InlineTab";
//@ts-ignore
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../../components/Loading";
//@ts-ignore
import { useHistory } from "react-router";
import { OrderField } from "./OrderField";
import { ScanPackage } from "./components/ScanPackage";

const QUERY = gql`
  query merchantOrderListBeta($status: CustomerOrderItemStatus, $limit: Int! = 10, $offset: Int! = 0) {
    merchantOrderListBeta(status: $status, limit: $limit, offset: $offset) {
      packageId
      uuid
      itemID
      status
      customerID
      code
      title
      supplierCode
      picture
      color
      orderDate
      size
      trackingNumber
      prepaidAmount
      fullPrice
      log {
        description
        date
      }
      package {
        id
        uuid
      }
    }
  }
`;

export function OrderListScreen(props: any) {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const { location, replace } = useHistory();
  const param = new URLSearchParams(location.search);
  const [index, setIndex] = useState<number>(location.hash ? Number(location.hash.charAt(1)) : 0);
  const [ostatus, setOstatus] = useState<any>("No");
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      status: Number(index) === 0 ? "WAITING" : index === 1 ? "PREPARED" : ostatus === "No" ? undefined : ostatus,
      offset: Number(offset) * Number(limit),
      limit: Number(limit),
    },
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    { text: "applications", to: "#" },
    { text: "orders", to: "#" },
    { text: "orders management", to: "/orders/list" },
    {
      text: index === 0 ? "Order To Prepare" : index === 1 ? "Prepared To Order" : "Orders Log",
      to: "#" + index,
    },
  ];

  useEffect(() => {
    if (!param.get("page")) {
      param.append("page", "1");
      replace({
        pathname: location.pathname,
        search: param.toString(),
      });
    }

    if (!param.get("limit")) {
      param.append("limit", "10");
      replace({
        pathname: location.pathname,
        search: param.toString(),
      });
    }
  }, [param, replace, location]);

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-12">
            <InlineTab tabIndex={index} onTabChange={setIndex}>
              <InlineTabContent alias="0" name="Order To Prepare">
                <Loading />
              </InlineTabContent>
              <InlineTabContent alias="1" name="Prepared To Order">
                <ScanPackage />
                <Loading />
              </InlineTabContent>
              <InlineTabContent alias="2" name="Orders Log">
                <div className="row">
                  <div className="col-3">
                    <select className="form-control" value={ostatus} onChange={(e) => setOstatus(e.target.value)}>
                      <option value="No">No Filter</option>
                      <option value="REQUEST_PICKUP">Shipment Request</option>
                      <option value="MERCHANT_SHIPPED">Merchant Shipped</option>
                      <option value="ARRIVED_AT_SHIPPER">Shipper Sent</option>
                      <option value="ARRIVED">Arrived at L192</option>
                      <option value="READY">Ready to Deliver</option>
                      <option value="DELIVERED">Delivered to Customer</option>
                      <option value="RETURNING">Returning from Customer</option>
                      <option value="RETURNED">Returned from Customer</option>
                      <option value="UNCOLLECTED">Uncollected by Customer</option>
                      <option value="DAMAGED_ITEM">Damaged Item Sent by merchant</option>
                      <option value="WRONG_ITEM">Wrong Item Sent by merchant</option>
                      <option value="DEPARTED">Departed</option>
                    </select>
                  </div>
                </div>
                <Loading />
              </InlineTabContent>
            </InlineTab>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-12">
          <InlineTab tabIndex={index} onTabChange={setIndex}>
            <InlineTabContent alias="0" name="Order To Prepare">
              <OrderField
                props={props}
                items={data.merchantOrderListBeta}
                tabIndex={index}
                onLimit={(e: any) => setLimit(e)}
                onOffset={(e: any) => setOffset(e)}
              />
            </InlineTabContent>
            <InlineTabContent alias="1" name="Prepared To Order">
              <ScanPackage />
              <OrderField
                props={props}
                items={data.merchantOrderListBeta}
                tabIndex={index}
                onLimit={(e: any) => setLimit(e)}
                onOffset={(e: any) => setOffset(e)}
              />
            </InlineTabContent>
            <InlineTabContent alias="2" name="Orders Log">
              <div className="row">
                <div className="col-3">
                  <select className="form-control" value={ostatus} onChange={(e) => setOstatus(e.target.value)}>
                    <option value="No">No Filter</option>
                    <option value="REQUEST_PICKUP">Shipment Request</option>
                    <option value="MERCHANT_SHIPPED">Merchant Shipped</option>
                    <option value="ARRIVED_AT_SHIPPER">Shipper Sent</option>
                    <option value="ARRIVED">Arrived at L192</option>
                    <option value="READY">Ready to Deliver</option>
                    <option value="DELIVERED">Delivered to Customer</option>
                    <option value="RETURNING">Returning from Customer</option>
                    <option value="RETURNED">Returned from Customer</option>
                    <option value="UNCOLLECTED">Uncollected by Customer</option>
                    <option value="DAMAGED_ITEM">Damaged Item Sent by merchant</option>
                    <option value="WRONG_ITEM">Wrong Item Sent by merchant</option>
                    <option value="DEPARTED">Departed</option>
                  </select>
                </div>
              </div>
              <OrderField
                props={props}
                items={data.merchantOrderListBeta}
                tabIndex={index}
                onLimit={(e: any) => setLimit(e)}
                onOffset={(e: any) => setOffset(e)}
              />
            </InlineTabContent>
          </InlineTab>
        </div>
      </div>
    </Content>
  );
}
